var __TEMP__ = require('./eq.js');var eq = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = assocIndexOf;
